export const enUS_globalTips = {
  'global.title.notfound': 'Sorry, the page you visited does not exist.',
  'global.title.backHome': 'Back Dashboard',
  'global.title.error': 'An error has occurred, try again later.',
  'global.title.download': 'Download',
  'global.title.more.filter': 'More filters',
  'global.title.less.filter': 'Less filters',
  'global.title.clean.filter': 'Clean filters',
  'global.title.notification': 'Notification',
  'global.title.range.date': 'Date range',
  'global.title.search': 'Search',
  'global.title.media': 'Media',
  'global.title.all.male': 'All',
  'global.title.all': 'All',
  'global.title.channel': 'Channel',
  'global.title.condition': 'Condition',
  'global.title.resolution': 'Resolution',
  'global.title.tags': 'Tags',
  'global.title.device': 'Device',
  'global.title.host': 'URL source',
  'global.title.country': 'Country',
  'global.title.city': 'City',
  'global.title.satisfaction': 'Satisfaction',
  'global.title.date': 'Date',
  'global.title.user': 'User',
  'global.title.unknown': 'Unknown',
  'global.title.interactions': 'Interactions',
  'global.title.not.response': 'No answer',
  'global.title.actions': 'Actions',
  'global.title.without': 'Without',
  'global.title.with': 'With',
  'global.title.today': 'Today',
  'global.title.yesterday': 'Yesterday',
  'global.title.this.week': 'This week',
  'global.title.last.week': 'Last week',
  'global.title.last.30.days': 'Last 30 days',
  'global.title.this.month': 'This month',
  'global.title.last.month': 'Last month',
  'global.title.this.quarter': 'This quarter',
  'global.title.last.quarter': 'Last quarter',
  'global.title.this.year': 'This year',
  'global.title.empty': 'There are no records',
  'global.title.back': 'Back',
  'global.title.spotter.title': 'Discover the power of your data with Spotter, your AI analyst',
  'global.title.spotter.description': 'With Spotter, you can find insights by asking direct questions about your data and instantly receive clear answers, dynamic visualizations, and smarter recommendations.'
};
